import React from 'react'

export default function DownloadIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={18}
            height={18}
            x={0}
            y={0}
            viewBox="0 0 64 64"
            style={{ enableBackground: "new 0 0 512 512" }}
            xmlSpace="preserve"
        >
            <g>
                <g data-name="Layer 41">
                    <path
                        d="M57.47 38.6a2 2 0 0 0-2 2v6.83a6.07 6.07 0 0 1-6.07 6.07H14.6a6.07 6.07 0 0 1-6.07-6.07V40.6a2 2 0 1 0-4 0v6.83A10.08 10.08 0 0 0 14.6 57.5h34.8a10.08 10.08 0 0 0 10.07-10.07V40.6a2 2 0 0 0-2-2z"
                        fill="currentcolor"
                        opacity={1}
                        data-original="#000000"
                    />
                    <path
                        d="M30.58 44.44a2 2 0 0 0 2.84 0L44.8 33.06a2 2 0 0 0-2.8-2.83l-8 8V8.5a2 2 0 0 0-4 0v29.7l-8-8a2 2 0 0 0-2.83 2.83z"
                        fill="currentcolor"
                        opacity={1}
                        data-original="#000000"
                    />
                </g>
            </g>
        </svg>
    )
}
